import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AgentesService } from 'src/app/services/agentes/agentes.service';
import { ExpedienteService } from 'src/app/services/expediente/expediente.service';
import { FechasPagoClientesService } from 'src/app/services/fechas-pago-clientes/fechas-pago-clientes.service';
import { PagosClientesService } from 'src/app/services/pagos-clientes/pagos-clientes.service';
import { PartidasService } from 'src/app/services/partidas/partidas.service';
import { PdfService } from 'src/app/services/pdf/pdf.service';
import { VentasService } from 'src/app/services/ventas/ventas.service';

import { HTMLdecode } from '../../utils/utils';

@Component({
  selector: 'app-detalle-expediente',
  templateUrl: './detalle-expediente.component.html',
  styleUrls: ['./detalle-expediente.component.css'],
})
export class DetalleExpedienteComponent implements OnInit {
  agente;
  expediente;
  venta;
  partidas = [];
  pagos_clientes = [];
  lista_pasajeros = [];
  fechas_pago_cliente = [];

  constructor(
    private route: ActivatedRoute,
    private _expedienteService: ExpedienteService,
    private _ventasService: VentasService,
    private _agentesService: AgentesService,
    private _pagosClienteService: PagosClientesService,
    private _partidasService: PartidasService,
    private _fechasPagoClientesService: FechasPagoClientesService,
    private _pdfService: PdfService
  ) {}

  ngOnInit() {
    let expediente_id = this.route.snapshot.paramMap.get('expediente_id');
    this._expedienteService
      .buscar_expedientes({ no_expediente: expediente_id })
      .subscribe((res: any) => {
        console.log('buscando', res);
        this.expediente = res.lista[0];
        this.check_venta(expediente_id);
        this.check_agente();
        this.check_pagos_cliente(expediente_id);
      });
  }
  check_agente() {
    this._agentesService
      .getById(this.expediente.agentes_id)
      .subscribe((res: any) => {
        this.agente = res.result;
      });
  }
  check_venta(expediente_id) {
    const condiciones = { absolutas: [{ expediente_id }], expediente_id };
    this._ventasService.filtrado(condiciones).subscribe((data: any) => {
      this.venta = data.lista[0];
      this.check_partidas(expediente_id);
      this.check_fechas_pago();
    });
  }
  check_pagos_cliente(expediente_id) {
    const condiciones = { absolutas: [{ expediente_id: expediente_id }] };
    this._pagosClienteService.filtrado(condiciones).subscribe((res: any) => {
      this.pagos_clientes = res.lista;
    });
  }
  check_partidas(expediente_id) {
    const condiciones = {
      absolutas: [{ expediente_id }, { ventas_id: this.venta.id }],
    };
    this._partidasService.filtrado(condiciones).subscribe((res: any) => {
      this.partidas = res.lista;
    });
  }
  check_fechas_pago() {
    this._fechasPagoClientesService
      .filtrado({ absolutas: [{ ventas_id: this.venta.id }] })
      .subscribe((res: any) => {
        this.fechas_pago_cliente = res.lista;

        /* this.fechas_pago_list = [];
        res.lista.forEach((item) => {
          if (item.estatus != "pagado") this.fechas_pago_list.push(item);
        });
        this.fechas_pago_list_conplete = res.lista;
        if (this.fechas_pago_list.length > 0)
          this.fecha_pago_cliente_selected = this.fechas_pago_list[0]; */
      });
  }
  async toPDF() {
    this.guardar_expendiente();

    const content = <HTMLScriptElement>(
      document.querySelector('.pdf_body_balance')
    ); //document.getElementById("body_pdf_balance");
    const footer = <HTMLScriptElement>(
      document.querySelector('.pdf_footer_balance')
    ); // document.getElementById("footerContent");
    const header = <HTMLScriptElement>(
      document.querySelector('.pdf_header_balance')
    ); //document.getElementById("headerContent");
    this._pdfService
      .generatePdf(header, footer, content)
      .subscribe((res: any) => {
        console.log(res);
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
        // window.open(res);
      });
  }
  guardar_expendiente() {
    // obtener contenido del html
    let element = document.getElementById('plantilla_selected_content');

    if (!element) return;
    let plantilla_element = `${element.innerHTML}`;

    // replace all break tags with new line
    plantilla_element = plantilla_element.replace(/<br\s*[\/]?>/gi, '\n');
    // let regex = /(<([^>]+)>)/gi;
    // let regex2 = "&nbsp;";
    // plantilla_element = plantilla_element.replace(regex, "");
    // plantilla_element = plantilla_element.replace(regex2, "\n");
    // // plantilla_element = plantilla_element.replace(";", "");
    // plantilla_element = plantilla_element.replace("&nbsp;&nbsp;", "\n");
    // replace all break tags with new line
    plantilla_element = plantilla_element.replace(/<br\s*[\/]?>/gi, '\n');
    // replace all end div tags with new line
    plantilla_element = plantilla_element.replace(/<\/div>/gi, '\n');
    // replace all close tags with new line
    // plantilla_element = plantilla_element.replace(/<\/([^>]+)>/gi, "\n");
    plantilla_element = plantilla_element.replace(/<\/([^>]+)>/gi, '');

    // replace all tags with new line
    plantilla_element = plantilla_element.replace(/<[^>]*>/gi, '');
    // replace all double spaces with single space

    plantilla_element = HTMLdecode(plantilla_element);

    console.log('plantilla_contrato', plantilla_element);
    this._expedienteService
      .update(this.expediente.id, {
        ...this.expediente,
        plantilla_contrato: plantilla_element,
      })
      .subscribe((res: any) => {});
  }
}
